import React from 'react';
import './DynamicColorSVG.css'; // Import external CSS file for styling

const DynamicColorSVG = ({ color, children }) => {
  return (
    <div className="cover-container">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 1350 750"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="background-svg"
      >
        <g opacity="0.45" filter="url(#filter0_f_5_1133)">
          <ellipse
            cx="683"
            cy="350.5"
            rx="253"
            ry="253.5"
            fill={`url(#paint0_linear_5_1133)`}
          />
        </g>
        <g opacity="0.45" filter="url(#filter1_f_5_1133)">
          <circle
            cx="325"
            cy="214"
            r="180"
            fill={`url(#paint1_linear_5_1133)`}
          />
        </g>
        <g opacity="0.45" filter="url(#filter2_f_5_1133)">
          <circle
            cx="1020"
            cy="524"
            r="201"
            fill={`url(#paint2_linear_5_1133)`}
          />
        </g>
        <path
          d="M1392.23 925.256C1421.64 196.018 523.491 432.696 506.225 -112.891L1556.35 -70.5423L1522.4 771.401L1392.23 925.256Z"
          fill={`url(#paint3_radial_5_1133)`}
          fillOpacity="0.24"
        />
        <g filter="url(#filter3_b_5_1133)">
          <path
            d="M274.098 -120.74C274.098 609.091 1161.98 336.415 1201.21 880.863L-325.19 880.863L-325.19 -120.74L274.098 -120.74Z"
            fill={`url(#paint4_radial_5_1133)`}
            fillOpacity="0.24"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_5_1133"
            x="110"
            y="-223"
            width="1146"
            height="1147"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="160" result="effect1_foregroundBlur_5_1133" />
          </filter>
          <filter
            id="filter1_f_5_1133"
            x="-175"
            y="-286"
            width="1000"
            height="1000"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="160" result="effect1_foregroundBlur_5_1133" />
          </filter>
          <filter
            id="filter2_f_5_1133"
            x="499"
            y="2.99976"
            width="1042"
            height="1042"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="160" result="effect1_foregroundBlur_5_1133" />
          </filter>
          <filter
            id="filter3_b_5_1133"
            x="-333.189"
            y="-128.74"
            width="1542.4"
            height="1017.6"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_5_1133" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_5_1133" result="shape" />
          </filter>

          <linearGradient
            id="paint0_linear_5_1133"
            x1="683"
            y1="96.9998"
            x2="683"
            y2="604"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.317152" stopColor={color} />
            <stop offset="1" stopColor="#716FFF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_5_1133"
            x1="325"
            y1="33.9998"
            x2="325"
            y2="394"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.317152" stopColor={color} />
            <stop offset="1" stopColor="#77E8E9" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_5_1133"
            x1="1020"
            y1="323"
            x2="1020"
            y2="725"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.317152" stopColor={color} />
            <stop offset="1" stopColor="#77E8E9" />
          </linearGradient>
          <radialGradient
            id="paint3_radial_5_1133"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1004.41 329.395) rotate(-91.2031) scale(364.878 433.08)"
          >
            <stop stopColor="white" />
            <stop offset="0.553917" stopColor="white" />
          </radialGradient>
          <radialGradient
            id="paint4_radial_5_1133"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(437.32 309.117) rotate(122.326) scale(733.346 870.422)"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>
      <div className="children-content" style={{ width:'100%', height:'100%'}}>
        {children}
      </div>
    </div>
  );
};

export default DynamicColorSVG;
